import ProductSettingsView from "./ProductSettingsView";

import "./ProductSettingsView.scss";

export * from "./ProductSettingsView.types";

export { ProductSettingsView };
